export default class splitDetailColModCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal, globalFn) {
        $scope.items = items1
        $scope.slje = '2'//  1:选择按数量拆分  2:选择按金额拆分
        $scope.splitInvoiceList = [{
            billId: $scope.items.singleDetailInfo.billId,
            matName: $scope.items.singleDetailInfo.matName, // 商品名称
            billDetailId: $scope.items.singleDetailInfo.billDetailId,
            billDetailIdList: [$scope.items.singleDetailInfo.billDetailId], // 明细id列表
            spec: $scope.items.singleDetailInfo.spec, // 规格型号
            quantity: '', // 数量
            amount: '', // 金额
            taxAmount: '', // 税额
            invoiceSN: '', // 发票序号 invoiceSN
            taxRate: $scope.items.singleDetailInfo.taxRate,
            unit: $scope.items.singleDetailInfo.unit,
            extra: 0, // 临时数据
            zdyinvoiceSN: '', // 自定义发票序号
            flag: 3,
        }, {
            billId: $scope.items.singleDetailInfo.billId,
            matName: $scope.items.singleDetailInfo.matName, // 商品名称
            billDetailId: $scope.items.singleDetailInfo.billDetailId,
            billDetailIdList: [$scope.items.singleDetailInfo.billDetailId], // 明细id列表
            spec: $scope.items.singleDetailInfo.spec, // 规格型号
            quantity: '', // 数量
            amount: '', // 金额
            taxAmount: '', // 税额
            invoiceSN: '', // 发票序号 invoiceSN
            taxRate: $scope.items.singleDetailInfo.taxRate,
            unit: $scope.items.singleDetailInfo.unit,
            extra: 0, // 临时数据
            zdyinvoiceSN: '', // 自定义发票序号
            flag: 3,
        }]
        $scope.items.singleDetailInfo.price = Number($scope.items.singleDetailInfo.price)
        $scope.splitQuantity = 0// 拆掉的数量
        $scope.splitAmount = 0// 拆掉的金额
        $scope.remainQuantity = $scope.items.singleDetailInfo.quantity // 剩余数量
        $scope.remainAmount = $scope.items.singleDetailInfo.amount // 剩余金额
        // 修改数组
        function toSelect2data(list) {
            const result = []
            for (let a = 0; a < list.length; a++) {
                const tempdata = { id: '', text: '' }
                tempdata.id = list[a]
                tempdata.text = list[a]
                result.push(tempdata)
            }
            return result
        }
        $scope.items.invoiceSNList = toSelect2data($scope.items.invoiceSNList)
        $scope.items.invoiceSNList.unshift({ id: '', text: '自定义' })


        // $scope.items.invoiceSNList.unshift(0)


        $scope.addSplitRow = function () {
            $scope.splitInvoiceList.push({
                billId: $scope.items.singleDetailInfo.billId,
                matName: $scope.items.singleDetailInfo.matName, // 商品名称
                billDetailId: $scope.items.singleDetailInfo.billDetailId,
                billDetailIdList: [$scope.items.singleDetailInfo.billDetailId], // 明细id列表
                spec: $scope.items.singleDetailInfo.spec, // 规格型号
                quantity: '', // 数量
                amount: '', // 金额
                taxAmount: '', // 税额
                invoiceSN: '', // 发票序号 invoiceSN
                taxRate: $scope.items.singleDetailInfo.taxRate,
                unit: $scope.items.singleDetailInfo.unit,
                extra: 0, // 临时数据
                zdyinvoiceSN: '', // 自定义发票序号
                flag: 3,
            })
        }


        // 税额计算 含税金额*税率/(1+税率)
        function TaxPrice(num1, num2) {
            return globalFn.Mul(num1, num2)
        }

        // 输入金额删除行
        $scope.amountDelRow = function ($index) {
            if ($scope.items.singleDetailInfo.quantity == null) {
                $scope.splitInvoiceList.splice($index, 1)
                // $scope.amountChange($index)
                $scope.splitAmount = 0
                for (var i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                    $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].amount, $scope.splitAmount)
                }
                // $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)//剩余金额
                if ($scope.remainAmount < 0) {
                    $scope.remainAmount = globalFn.cutOutNnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)// 剩余金额
                } else {
                    $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)// 剩余金额
                }
            } else {
                $scope.splitInvoiceList.splice($index, 1)
                $scope.splitQuantity = 0
                $scope.splitAmount = 0
                for (var i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                    $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].amount, $scope.splitAmount)
                    $scope.splitQuantity = globalFn.Add($scope.splitInvoiceList[i].quantity, $scope.splitQuantity)
                }
                // $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)//剩余金额
                if ($scope.remainAmount < 0) {
                    $scope.remainAmount = globalFn.cutOutNnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)// 剩余金额
                } else {
                    $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)// 剩余金额
                }
                $scope.remainQuantity = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity), 15)// 剩余数量
            }
        //     $scope.splitInvoiceList.splice($index,1)
        //    // $scope.quantityChange()
        //    $scope.splitQuantity = 0;
        //    $scope.splitAmount = 0;
        //    for (var i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
        //     $scope.splitQuantity = globalFn.Add($scope.splitQuantity, $scope.splitInvoiceList[i].quantity)
        //     $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].extra, $scope.splitAmount)
        //     //$.extend($scope.splitInvoiceList[i],$scope.items.singleDetailInfo,$scope.splitInvoiceList[i])
        //     }
        //     $scope.remainQuantity = globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity)//剩余数量
        //     $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)//剩余金额
        }

        // cutOutPnumber 截取正数   cutOutNnumber  截取负数
        // 输入数量删除行
        $scope.quantityDelRow = function ($index) {
            $scope.splitInvoiceList.splice($index, 1)
            // $scope.quantityChange()
            $scope.splitQuantity = 0
            $scope.splitAmount = 0
            for (let i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                $scope.splitQuantity = globalFn.Add($scope.splitQuantity, $scope.splitInvoiceList[i].quantity)
                $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].extra, $scope.splitAmount)
            }
            $scope.remainQuantity = globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity)// 剩余数量
            // $scope.remainAmount = globalFn.selfToFixed(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)//剩余金额
            if ($scope.remainAmount < 0) {
                $scope.remainAmount = globalFn.cutOutNnumber($scope.remainAmount, 2)// 剩余金额
            } else {
                $scope.remainAmount = globalFn.cutOutPnumber($scope.remainAmount, 2)// 剩余金额
            }
        }
        // 计算拆掉的数量
        $scope.quantityChange = function ($index) {
            $scope.splitInvoiceList[$index].quantity = Number(globalFn.cutOutPnumber($scope.splitInvoiceList[$index].quantity, 15))
            $scope.splitQuantity = 0
            $scope.splitAmount = 0
            try {
                $scope.splitInvoiceList[$index].extra = globalFn.Mul($scope.splitInvoiceList[$index].quantity, $scope.items.singleDetailInfo.price)
                $scope.splitInvoiceList[$index].amount = Number(globalFn.selfToFixed($scope.splitInvoiceList[$index].extra, 2))
                $scope.splitInvoiceList[$index].taxAmount = TaxPrice($scope.splitInvoiceList[$index].extra, $scope.items.singleDetailInfo.taxRate)
                $scope.splitInvoiceList[$index].taxAmount = globalFn.selfToFixed($scope.splitInvoiceList[$index].taxAmount, 2)
            } catch (error) {

            }
            for (let i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                $scope.splitQuantity = globalFn.Add($scope.splitQuantity, $scope.splitInvoiceList[i].quantity)
                $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].extra, $scope.splitAmount)
            }

            $scope.remainAmount = globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount)
            $scope.remainQuantity = globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity)

            if ($scope.remainQuantity < 0) {
                $scope.remainQuantity = globalFn.cutOutNnumber($scope.remainQuantity, 15)// 剩余数量
            } else {
                $scope.remainQuantity = globalFn.cutOutPnumber($scope.remainQuantity, 15)// 剩余数量
            }

            if ($scope.remainAmount < 0) {
                $scope.remainAmount = globalFn.cutOutNnumber($scope.remainAmount, 2)// 剩余金额
            } else {
                $scope.remainAmount = globalFn.cutOutPnumber($scope.remainAmount, 2)// 剩余金额
            }
            // $scope.remainAmount
            // $scope.remainQuantity = globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity)//剩余数量
            // $scope.remainAmount = globalFn.cutOutPnumber(globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount), 2)//剩余金额
        }


        // 按金额拆分
        $scope.amountChange = function ($index) {
            $scope.splitInvoiceList[$index].amount = Number(globalFn.cutOutPnumber($scope.splitInvoiceList[$index].amount, 2))
            if ($scope.items.singleDetailInfo.quantity == null) {
                $scope.splitAmount = 0
                $scope.splitInvoiceList[$index].taxAmount = globalFn.selfToFixed(globalFn.Mul($scope.splitInvoiceList[$index].amount, $scope.items.singleDetailInfo.taxRate), 2)
                for (var i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                    $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].amount, $scope.splitAmount)
                }
                $scope.remainAmount = globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount)

                $scope.remainAmount = globalFn.selfToFixed($scope.remainAmount, 2)// 剩余金额
            } else {
                $scope.splitQuantity = 0
                $scope.splitAmount = 0
                try {
                    $scope.splitInvoiceList[$index].quantity = Number(globalFn.selfToFixed(globalFn.Div($scope.splitInvoiceList[$index].amount, $scope.items.singleDetailInfo.price), 2))
                    $scope.splitInvoiceList[$index].taxAmount = globalFn.selfToFixed(globalFn.Mul($scope.splitInvoiceList[$index].amount, $scope.items.singleDetailInfo.taxRate), 2)
                } catch (error) {

                }

                for (var i = 0, l = $scope.splitInvoiceList.length; i < l; i++) {
                    $scope.splitAmount = globalFn.Add($scope.splitInvoiceList[i].amount, $scope.splitAmount)
                    $scope.splitQuantity = globalFn.Add($scope.splitInvoiceList[i].quantity, $scope.splitQuantity)
                }
                $scope.remainAmount = globalFn.Sub($scope.items.singleDetailInfo.amount, $scope.splitAmount)

                if ($scope.remainAmount < 0) {
                    $scope.remainAmount = globalFn.cutOutNnumber($scope.remainAmount, 2)// 剩余金额
                } else {
                    $scope.remainAmount = globalFn.cutOutPnumber($scope.remainAmount, 2)// 剩余金额
                }

                $scope.remainQuantity = globalFn.Sub($scope.items.singleDetailInfo.quantity, $scope.splitQuantity)

                $scope.remainQuantity = Number(globalFn.selfToFixed($scope.remainQuantity, 15))// 剩余金额
            }
        }


        const reg = /^[0-9]*$/
        // 检查行是否符合
        function checkRow() {
            const list = $scope.splitInvoiceList
            const len = $scope.splitInvoiceList.length
            if ($scope.items.singleDetailInfo.quantity == null) {
                for (var i = 0; i < len; i++) {
                    if (list[i].amount < 0) {
                        logger.logError('输入值必须大于0')
                        return false
                    }
                    if (list[i].amount == 0 || list[i].amount == null) {
                        logger.logError(`第${i + 1}行金额不能为空`)
                        return false
                    }
                    // if(list[i].invoiceSN==""){
                    //     list[i].invoiceSN = list[i].zdyinvoiceSN
                    // }
                    if ((list[i].invoiceSN == '' && !reg.test(list[i].zdyinvoiceSN))) {
                        logger.logError(`第${i + 1}行发票序号有误,请输入3位以内的正整数`)

                        return false
                    }

                    if (list[i].zdyinvoiceSN < 1) {
                        logger.logError(`第${i + 1}行发票序号有误,请输入3位以内的正整数`)
                        return false
                    }
                }
                return true
            }
            for (var i = 0; i < len; i++) {
                if (list[i].amount < 0 || list[i].quantity <= 0) {
                    logger.logError('输入值必须大于0')
                    return false
                }
                if (list[i].amount == 0 || list[i].amount == null) {
                    logger.logError(`第${i + 1}行金额不能为空`)
                    return false
                }
                if (list[i].invoiceSN == '' && !reg.test(list[i].zdyinvoiceSN)) {
                    logger.logError(`第${i + 1}行发票序号有误,请输入3位以内的正整数`)
                    return false
                }
                if (list[i].zdyinvoiceSN < 1 && list[i].invoiceSN == '') {
                    logger.logError(`第${i + 1}行发票序号有误,请输入3位以内的正整数`)
                    return false
                }
            }
            return true
        }

        // 计算拆分前税额和拆分以后的税额,金额,数量
        function isOneTaxAmount() {
            let afterTaxAmount = 0
            const afterQuantity = 0
            const afterAmount = 0
            for (var a in $scope.splitInvoiceList) {
                afterTaxAmount += Number($scope.splitInvoiceList[a].taxAmount)
            }
            if ($scope.items.singleDetailInfo.taxAmount == afterTaxAmount) {
                return true
            }
            for (var a in $scope.splitInvoiceList) {
                if ($scope.splitInvoiceList[a].taxAmount > 0.1) {
                    $scope.splitInvoiceList[a].taxAmount = Number(globalFn.Add($scope.splitInvoiceList[a].taxAmount, globalFn.selfToFixed($scope.items.singleDetailInfo.taxAmount - afterTaxAmount, 2)))
                    return
                }
            }
        }
        function isOneQuantity() {
            let afterQuantity = 0
            const l = $scope.splitInvoiceList.length
            for (const a in $scope.splitInvoiceList) {
                afterQuantity = globalFn.Add(afterQuantity, Number($scope.splitInvoiceList[a].quantity))
            }

            if ($scope.items.singleDetailInfo.Quantity != afterQuantity) {
                $scope.splitInvoiceList[l - 1].quantity = Number(globalFn.Add($scope.splitInvoiceList[l - 1].quantity, globalFn.selfToFixed($scope.items.singleDetailInfo.quantity - afterQuantity, 15)))
            }
        }
        function isOneAmount() {
            let afterAmount = 0
            const l = $scope.splitInvoiceList.length
            for (const a in $scope.splitInvoiceList) {
                afterAmount = globalFn.Add(afterAmount, Number($scope.splitInvoiceList[a].amount))
            }
            console.log(afterAmount)
            if ($scope.items.singleDetailInfo.Amount != afterAmount) {
                const a = globalFn.Sub($scope.items.singleDetailInfo.amount, afterAmount)
                $scope.splitInvoiceList[l - 1].amount = Number(globalFn.Add($scope.splitInvoiceList[l - 1].amount, a))
            }
        }

        function remainValid() {
            if ($scope.items.singleDetailInfo.quantity == null) {
                if ($scope.remainAmount != 0) {
                    return false
                }
                return true
            }
            return $scope.remainAmount == 0 || $scope.remainQuantity == 0
        }

        $scope.ok = function () {
            if (!checkRow()) {
                // for(var a in $scope.splitInvoiceList){
                //     $scope.splitInvoiceList[a].invoiceSN='';
                // }
                return
            }
            const list = $scope.splitInvoiceList
            const len = $scope.splitInvoiceList.length
            if (!remainValid()) {
                logger.logError('拆分明细剩余金额或剩余数量必须拆分至0,方可提交')
                return
            }
            if ($scope.items.singleDetailInfo.quantity == null && $scope.remainAmount == 0) {
                // 按金额拆分
                for (var i = 0; i < len; i++) {
                    if (list[i].invoiceSN == '') {
                        list[i].invoiceSN = list[i].zdyinvoiceSN
                    }
                }
                isOneAmount()
                isOneTaxAmount()

                $uibModalInstance.close($scope.splitInvoiceList)
            } else if ($scope.remainQuantity == 0 || $scope.remainAmount == 0) {
                for (var i = 0; i < len; i++) {
                    if (list[i].invoiceSN == '') {
                        list[i].invoiceSN = list[i].zdyinvoiceSN
                    }
                }

                isOneAmount()
                isOneQuantity()
                isOneTaxAmount()
                $uibModalInstance.close($scope.splitInvoiceList)
            } else {
                logger.logError('拆分明细剩余金额或剩余数量必须拆分至0,方可提交')
            }
        }

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/splitDetailColModCtrl.js